import styled from 'styled-components';

export const Blocker = styled.div`
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    background: ${props => props.theme.modalBlockerBackground};
    opacity: 0.8;
    z-index: 7;
`;

export const ModalContainer = styled.div`
    position: fixed;
    z-index: 8;
    ${props => (props.large ? 'width: 740px;' : 'width: 640px;')}
    height: 100%;

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    overflow-y: auto;
    overflow-x: hidden;
    outline: none !important;

    .modal {
        position: relative;
        width: 100%;
        margin: 10px 0;
        overflow-y: auto;
        background-color: ${props => props.theme.modalBackgroundColor};

        .bt-close {
            position: absolute;
            top: 0;
            right: 0;
        }

        @media screen and (max-width: ${props => props.theme.mobile}) {
            width: 100%;
            padding: 0;
        }
    }

    ${props =>
        props.large &&
        `
        @media screen and (max-width: ${props.theme.mobile}) {
            width: 100%;
            padding: 0 20px;
            margin: 0;
        }
    `}

    @media screen and (min-width: ${props => props.theme.medium}) and (max-width: ${props =>
    props.theme.large}) {
        &.conteneur-mobile {
            min-width: 600px;
            width: 600px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/modal/ModalRootStyle.js